import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive'
import { fetchApprovals, taskCleared, updatePreviousSystemCounts, approveTask, rejectTask, sendStats } from '../actions';
import { withOktaAuth } from '@okta/okta-react';
import { css } from "@emotion/react";
import BeatLoader from "react-spinners/BeatLoader";



//
// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class NotificationListBs extends React.Component {

    //fetch latest data and pass auth Obj with tokens for API call
    getUserDetails = async () => {
        let authObj = {};
        if (this.props.authState.isAuthenticated) {
            const userInfo = await this.props.oktaAuth.getUser();
            authObj.curUserInfo = userInfo;
            authObj.token = this.props.authState.accessToken;
            //console.log("AUTH OBJ:", authObj);
            await this.props.fetchApprovals(authObj);

            //console.log("I AM IN THE GETUSERDETAILS ABOUT TO CALL UPDATE PREVIOUS SYSTEM COUNTS")
            await this.props.updatePreviousSystemCounts(this.props.curSystemCounts);
        }
    }



    getUserDetails2 = async () => {
        let authObj = {};
        if (this.props.authState.isAuthenticated) {
            const userInfo = await this.props.oktaAuth.getUser();
            authObj.curUserInfo = userInfo;
            authObj.token = this.props.authState.accessToken;
            //console.log("Calling fetchApprovals action, should I clear cleared list here???");
            await this.props.fetchApprovals(authObj);
        }
    }

    //set counts for previous count state
    setPreviousCounts = async () => {
        //only update when the first data fetch has been finished
        //console.log("INSIDE IF in setPreviousCounts function, have not gone in yet");
        if (this.props.dataFetchComplete === true && this.props.isInitialDataFromRefresh === true) {
            // console.log("UPDATED PREVIOUS COUNTS IN FUNCTION, did go inside");
            await this.props.updatePreviousSystemCounts(this.props.curSystemCounts);
            // this.props.curSystemCounts[2] = 1;
            // this.props.curSystemCounts[3] = 1;
            //show popup
            await this.showPopUpNotification();
        }
    }

    //function with config of pop up notification
    showPopUpNotification = async () => {

        //let testMessage = "SAP QN"; //this will be dynamic
        let notifMessage = "New tasks in: "
        let showNotification = false;

        //logic
        if (this.props.previousSystemCounts[1].amount < this.props.curSystemCounts[1].amount) {
            notifMessage = notifMessage + "Agile ";
            showNotification = true;
        }
        // if(this.props.previousSystemCounts[2].amount < this.props.curSystemCounts[2].amount) {
        //     // notifMessage = notifMessage + "Ariba ";
        //     // showNotification = true;
        // }
        if (this.props.previousSystemCounts[2].amount < this.props.curSystemCounts[2].amount) {
            notifMessage = notifMessage + "ISU ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[3].amount < this.props.curSystemCounts[3].amount) {
            notifMessage = notifMessage + "SAP QN ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[4].amount < this.props.curSystemCounts[4].amount) {
            notifMessage = notifMessage + "Coupa ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[5].amount < this.props.curSystemCounts[5].amount) {
            notifMessage = notifMessage + "SAM ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[6].amount < this.props.curSystemCounts[6].amount) {
            notifMessage = notifMessage + "HelpNow ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[7].amount < this.props.curSystemCounts[7].amount) {
            notifMessage = notifMessage + "Trackwise ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[8].amount < this.props.curSystemCounts[8].amount) {
            notifMessage = notifMessage + "Ivalua ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[9].amount < this.props.curSystemCounts[9].amount) {
            notifMessage = notifMessage + "RCE ServiceNow ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[10].amount < this.props.curSystemCounts[10].amount) {
            notifMessage = notifMessage + "Concur ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[11].amount < this.props.curSystemCounts[11].amount) {
            notifMessage = notifMessage + "Neptune MT";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[12].amount < this.props.curSystemCounts[12].amount) {
            notifMessage = notifMessage + "Fieldglass ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[13].amount < this.props.curSystemCounts[13].amount) {
            notifMessage = notifMessage + "SmartRecruiters ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[14].amount < this.props.curSystemCounts[14].amount) {
            notifMessage = notifMessage + "IT TimeSheet ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[15].amount < this.props.curSystemCounts[15].amount) {
            notifMessage = notifMessage + "Neptune PS ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[16].amount < this.props.curSystemCounts[16].amount) {
            notifMessage = notifMessage + "My HCM ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[17].amount < this.props.curSystemCounts[17].amount) {
            notifMessage = notifMessage + "MES ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[18].amount < this.props.curSystemCounts[18].amount) {
            notifMessage = notifMessage + "Adobe Sign ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[19].amount < this.props.curSystemCounts[19].amount) {
            notifMessage = notifMessage + "Archibus ";
            showNotification = true;
        }
        if (this.props.previousSystemCounts[20].amount < this.props.curSystemCounts[20].amount) {
            notifMessage = notifMessage + "Purchase Order ";
            showNotification = true;
        }
        // if (this.props.previousSystemCounts[21].amount < this.props.curSystemCounts[20].amount) {
        //     notifMessage = notifMessage + "Purchase Order ";
        //     showNotification = true;
        // }



        // console.log("I am about to possibly show a push notification");
        //console.log(notifMessage);

        //only show if counter increased from last time else don't show a toast
        if (showNotification === true) {
            //console.log("SHOW THE PUSH NOTIFICATION");
            //only show if there are new notifications as compared to last time
            // toast.success(notifMessage, {
            //     style: {
            //         borderRadius: '10px',
            //         background: '#1C23BA',
            //         color: '#fff',
            //     },
            //     iconTheme: {
            //         primary: '#FFFAEE',
            //         secondary: '#1C23BA',
            //     },
            //     position: "bottom-center",
            //     duration: 6000,
            // });
        }
    };

    //Get the access token from user and othere user details
    componentDidMount() {
        //call initial fetch data only when there is no user object
        if (Object.keys(this.props.user).length === 0) {
            this.getUserDetails();
            //set initial count numbers as previousCount in state
            //this.setPreviousCounts();
            // this.props.updatePreviousSystemCounts(this.props.curSystemCounts);   
        }
        //set time to refresh every 1 hour
        setInterval(() => {
            // console.log("Refreshing data with interval function");
            //this.props.updatePreviousSystemCounts(this.props.curSystemCounts);
            this.getUserDetails2();

            //showPopup if there is a new pending task
            // this.showPopUpNotification();

            //update previous counts
            this.setPreviousCounts();
            //this.showPopUpNotification();
        }, 14400000); // 60000 => 1 minute 3600000 => 1hour  14400000 => 4hours
    }


    renderSamEntitlements(approval) {
        //might have to add await async here and in main function too.
        //     const myArr = [
        //         {
        //         entitlement: "A.B. Medica Partner Manager"
        //     },
        //     {
        //         entitlement:"Salesforce SFDC-Users UAT"
        //     },
        // ];
        if (approval.approval.entitlementArr.length > 0) {
            // console.log("CUR APPROVAL ARRAY: ", approval.approval.finalAppArr);
            let curCount = 0;
            return approval.approval.entitlementArr.map((i) => {

                return (
                    <span key={i.myKey} className="badge badge-count" style={{ marginLeft: "3px" }}>{i.name}</span>
                );
            })
        }
        //console.log("I AM HEERERERERER", myArr)
        //     <span class="badge badge-count">Salesforce SFDC-Users UAT</span>
        // )
    }

    renderSamApplications(approval) {
        //need a loop for Entitlements

        //need a loop for Applications

        //will need two seperate arrays in State, one for each type
        const myArr = [
            "Salesforce",
            "IIQ"
        ];


        //console.log("CUR APPROVAL ARRAY: ", approval.approval.finalAppArr);
        if (approval.approval.finalAppArr.length > 0) {
            // console.log("CUR APPROVAL ARRAY: ", approval.approval.finalAppArr);
            let curCount = 0;
            return approval.approval.finalAppArr.map((i) => {
                curCount++;
                return (
                    <span key={i.myKey} className="badge badge-count" style={{ marginLeft: "3px" }}>{i.name}</span>
                );
            })
        }
    }

    renderList() {
        //console.log("Version: 1.4.7");
        //let newArry = this.props.approvalList.filter(approval => approval.sysName == this.props.curSystem.sysName);
        let filteredApps = [];
        let temp1 = []; //will contain ISU data during 'All' selection
        let temp2 = []; //will contain other system data during 'All" selection
        let finalSysName;

        //get user uid necessary for stats API call
        let statsUid = this.props.user.preferred_username;
        if (statsUid) {
            const index = statsUid.indexOf("@");
            statsUid = statsUid.substring(0, index);
            statsUid = statsUid.toLowerCase();
        }

        //filter based on app name selection
        if (this.props.curSystem.sysName === "All") {
            filteredApps = this.props.approvalList;
            // console.log(filteredApps);
        } else if (this.props.curSystem.sysName === "Agile") {
            finalSysName = "agile"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        } else if (this.props.curSystem.sysName === "ISU") {
            finalSysName = "isu"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        } else if (this.props.curSystem.sysName === "SAP QN") {
            finalSysName = "sap qn"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        } else if (this.props.curSystem.sysName === "Coupa") {
            finalSysName = "coupa"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "SAM") {
            finalSysName = "sam"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "HelpNow") {
            finalSysName = "helpnow"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        } else if (this.props.curSystem.sysName === "Trackwise") {
            finalSysName = "trackwise"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        } else if (this.props.curSystem.sysName === "Ivalua") {
            finalSysName = "ivalua"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        } else if (this.props.curSystem.sysName === "RCE ServiceNow") {
            finalSysName = "rce servicenow"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "IT Timesheet") {
            finalSysName = "it timesheet"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "Concur") {
            finalSysName = "concur"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "Neptune MT") {
            finalSysName = "neptune mt"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "Fieldglass") {
            finalSysName = "fieldglass"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "SmartRecruiters") {
            finalSysName = "smartrecruiters"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "Neptune PS") {
            finalSysName = "neptune ps"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "My HCM") {
            finalSysName = "my hcm"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "MES") {
            finalSysName = "mes"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "Adobe Sign") {
            finalSysName = "adobe sign"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "Archibus Moves") {
            finalSysName = "archibus moves"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "Workday") {
            finalSysName = "workday"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "Purchase Order") {
            finalSysName = "purchase order"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "Workforce") {
            finalSysName = "workforce"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "Change Record") {
            finalSysName = "change record"
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }
        else if (this.props.curSystem.sysName === "Archibus Maint.") {
            finalSysName = "archibus maint."
            filteredApps = this.props.approvalList.filter(curApproval => curApproval.systemName === finalSysName);
        }


        //find days count from creation date for each approval
        for (let x of filteredApps) {

            //let date1 = new Date("2021-01-25".split("-"));
            let date1 = new Date();
            //console.log("Final Date: ",date1)
            // console.log("Test Date: ", testDate);
            // console.log("Cur record: ", x.systemName);
            //console.log("assignedData: ", x.assignedDate);
            //console.log("assignedData split: ", x.assignedDate.split("-"));
            let splitDate = x.assignedDate.split("-");
            //console.log("date2 test:", new Date(splitDate[0],splitDate[1]-1,splitDate[2]));
            let date2 = new Date(splitDate[0], splitDate[1] - 1, splitDate[2]);
            // console.log("date2: ", date2);
            var timeDiff = Math.abs(date2.getTime() - date1.getTime());
            // console.log("timeDiff: ", timeDiff);
            if (x.systemName == "neptune mt") {
                var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
            } else {
                var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
            }
            //console.log("diffDays: ", diffDays);


            //creating message to show in UI with day counts
            if (x.systemName === "isu") {
                x.daysCount = x.daysRemaining - 1;
                if (x.daysCount == 0) {
                    x.dateMessage = `Due Today!`;
                } else if (x.daysCount < 0) {
                    x.dateMessage = `Past Due!`;
                } else {
                    let d = new Date();//today
                    d.setDate(d.getDate() + x.daysCount);
                    let finalIsuDueDate = d.toString();
                    finalIsuDueDate = finalIsuDueDate.replace(/202(\d).*/g, "");
                    x.dateMessage = `Due in ${x.daysCount} days on ${finalIsuDueDate}`;
                }
            } else {
                x.daysCount = diffDays
                //console.log("x.days count: " ,x.daysCount)
                x.dateMessage = `Created ${x.daysCount} days ago`
            }
        }

        //fill temp arrays
        temp1 = filteredApps.filter(curApproval => curApproval.systemName === "isu");
        temp2 = filteredApps.filter(curApproval => curApproval.systemName === "agile" ||
            curApproval.systemName === "sap qn"
            || curApproval.systemName === "coupa"
            || curApproval.systemName === "sam"
            || curApproval.systemName === "helpnow"
            || curApproval.systemName === "trackwise"
            || curApproval.systemName === "ivalua"
            || curApproval.systemName === "rce servicenow"
            || curApproval.systemName === "concur"
            || curApproval.systemName === "neptune mt"
            || curApproval.systemName === "fieldglass"
            || curApproval.systemName === "smartrecruiters"
            || curApproval.systemName === "it timesheet"
            || curApproval.systemName === "neptune ps"
            || curApproval.systemName === "my hcm"
            || curApproval.systemName === "mes"
            || curApproval.systemName === "adobe sign"
            || curApproval.systemName === "archibus moves"
            || curApproval.systemName === "workday"
            || curApproval.systemName === "purchase order"
            || curApproval.systemName === "workforce"
            || curApproval.systemName === "archibus maint."
            || curApproval.systemName === "change record"
        );

        // console.log("Before date filter", filteredApps);
        //Filter by currrent date range filter
        if (this.props.dayFilter === "all") {
            filteredApps = filteredApps;//nothing to filter here
        }
        else if (this.props.dayFilter === "0-3 days") {
            if (this.props.curSystem.sysName === "ISU") {
                filteredApps = filteredApps.filter(curApproval => curApproval.daysCount > 10);
            }
            else if (this.props.curSystem.sysName === "All") {
                //sort ISU specific and the rest sort specific then join
                temp1 = temp1.filter(curApproval => curApproval.daysCount < 16 && curApproval.daysCount > 10);
                temp2 = temp2.filter(curApproval => curApproval.daysCount < 4);
                filteredApps = temp1.concat(temp2); //join both
            }
            else {
                filteredApps = filteredApps.filter(curApproval => curApproval.daysCount < 4);
            }
        } else if (this.props.dayFilter === "4-7 days") {
            if (this.props.curSystem.sysName === "ISU") {
                filteredApps = filteredApps.filter(curApproval => curApproval.daysCount < 11 && curApproval.daysCount > 6);
            }
            else if (this.props.curSystem.sysName === "All") {
                //sort ISU specific and the rest sort specific then join
                temp1 = temp1.filter(curApproval => curApproval.daysCount < 11 && curApproval.daysCount > 6);
                temp2 = temp2.filter(curApproval => curApproval.daysCount < 8 && curApproval.daysCount > 3);
                filteredApps = temp1.concat(temp2); //join both
            } else {
                filteredApps = filteredApps.filter(curApproval => curApproval.daysCount < 8 && curApproval.daysCount > 3);
            }
        } else if (this.props.dayFilter === "7+ days") {
            if (this.props.curSystem.sysName === "ISU") {
                filteredApps = filteredApps.filter(curApproval => curApproval.daysCount < 7);
            }
            else if (this.props.curSystem.sysName === "All") {
                //sort ISU specific and the rest sort specific then join
                temp1 = temp1.filter(curApproval => curApproval.daysCount < 7);
                temp2 = temp2.filter(curApproval => curApproval.daysCount > 7);
                filteredApps = temp1.concat(temp2); //join both
            }
            else {
                filteredApps = filteredApps.filter(curApproval => curApproval.daysCount > 7);
            }
        }
        // console.log("After date filter", filteredApps);


        //filter approvals by earliest to latest due date
        //filteredApps.sort((a,b) => Number(a.daysCount) - Number(b.daysCount));
        //filter approvals by latest to newest creation date
        filteredApps.sort((a, b) => Number(b.daysCount) - Number(a.daysCount));
        filteredApps.sort((a, b) => {
            if (a.systemName == "isu" && b.systemName == "isu") {
                return Number(a.daysCount) - Number(b.daysCount)
            }
        });




        //if no records for current filter after data fetch
        if (filteredApps.length < 1 && this.props.dataFetchComplete === true) {
            //console.log("I AM SUPPOSED TO BE IN HERE");
            return (
                <div>
                    <h3>No records available here</h3>
                </div>
            );
        }

        //show loading while fetching data
        if (this.props.dataFetchComplete === "false") {
            return (
                <div>
                    {/* <h3>No records available here</h3> */}
                    <div className="sweet-loading">
                        <h3>Fetching details...</h3>
                        <BeatLoader css={override} size={12} color={"#1C23BA"} loading={true} speedMultiplier={0.8} />
                    </div>
                </div>

            );
        }

        return filteredApps.map((approval) => {
            //console.log("APPROVAL LENGTH INSIDE: ",filteredApps.length);
            //limit description length
            let finalDescription = approval.description;
            if (finalDescription && finalDescription.length > 100) {
                // console.log("it is greater");
                finalDescription = finalDescription.substr(0, 100);
            }



            // console.log(today);
            if (this.props.curSystem != null && this.props.curSystem.sysName === approval.sysName) {
                //console.log("found one!");
            }

            let curApprovalSysname;
            let statAppname;
            let appColor;
            if (approval.systemName === "agile") {
                curApprovalSysname = "Agile ACCS";
                statAppname = "agile";
                appColor = "bg-danger";
                //approval.systemName = "agile";
            } else if (approval.systemName === "isu") {
                curApprovalSysname = "ISU";
                statAppname = "isu";
                appColor = "bg-secondary";
            } else if (approval.systemName === "sap qn") {
                curApprovalSysname = "SAP QN";
                statAppname = "sapqn";
            } else if (approval.systemName === "coupa") {
                curApprovalSysname = "Coupa";
                statAppname = "coupa";
            }
            else if (approval.systemName === "sam") {
                curApprovalSysname = "SAM";
                statAppname = "sam";
            }
            else if (approval.systemName === "helpnow") {
                curApprovalSysname = "HelpNow";
                statAppname = "helpnow";
            } else if (approval.systemName === "trackwise") {
                curApprovalSysname = "Trackwise";
                statAppname = "trackwise";
            } else if (approval.systemName === "ivalua") {
                curApprovalSysname = "Ivalua";
                statAppname = "ivalua";
            } else if (approval.systemName === "rce servicenow") {
                curApprovalSysname = "RCE ServiceNow";
                statAppname = "rce";
            } else if (approval.systemName === "concur") {
                curApprovalSysname = "Concur";
                statAppname = "concur";
            } else if (approval.systemName === "neptune mt") {
                curApprovalSysname = "Neptune MT";
                statAppname = "neptunemt";
            } else if (approval.systemName === "fieldglass") {
                curApprovalSysname = "Fieldglass";
                statAppname = "fieldglass";
            } else if (approval.systemName === "smartrecruiters") {
                curApprovalSysname = "SmartRecruiters";
                statAppname = "smartrecruiters";
            }
            else if (approval.systemName === "it timesheet") {
                curApprovalSysname = "IT Timesheet";
                statAppname = "ittimesheet";
            }
            else if (approval.systemName === "neptune ps") {
                curApprovalSysname = "Neptune PS";
                statAppname = "neptuneps";
            }
            else if (approval.systemName === "my hcm") {
                curApprovalSysname = "My HCM";
                statAppname = "myhcm";
            }
            else if (approval.systemName === "mes") {
                curApprovalSysname = "MES";
                statAppname = "mes";
            }
            else if (approval.systemName === "adobe sign") {
                curApprovalSysname = "Adobe Sign";
                statAppname = "adobesign";
            }
            else if (approval.systemName === "archibus moves") {
                curApprovalSysname = "Archibus Moves";
                statAppname = "archibus";
            }
            else if (approval.systemName === "workday") {
                curApprovalSysname = "Workday";
                statAppname = "workday";
            }
            else if (approval.systemName === "purchase order") {
                curApprovalSysname = "Purchase Order";
                statAppname = "purchase order";
            }
            else if (approval.systemName === "workforce") {
                curApprovalSysname = "Workforce";
                statAppname = "workforce";
            }
            else if (approval.systemName === "change record") {
                curApprovalSysname = "Change Record";
                statAppname = "sapchange";
            }
            else if (approval.systemName === "archibus maint.") {
                curApprovalSysname = "Archibus Maint.";
                statAppname = "archibusmaintenance";
            }

            return (
                <div key={approval.id} >
                    {/* Start of EQUALS condition for SAPQN */}
                    {curApprovalSysname == "SAP QN" &&
                        <div className="d-flex">
                            <a>
                                <div className="avatar">
                                    <span className="avatar-title rounded-circle border border-white" style={{ background: "#1C23BA" }}>{curApprovalSysname.charAt(0) + curApprovalSysname.charAt(1)}</span>
                                </div>
                            </a>
                            <MediaQuery minDeviceWidth={1225}>
                                <div className="flex-1 ml-3 pt-1">
                                    <h6 className="text-uppercase mb-1">{curApprovalSysname}</h6>
                                    <h6 className="text-uppercase fw-bold mb-1">Notification:<span className="pl-3 text-muted text"> {approval.title} </span></h6>
                                    <h6 className="text-uppercase fw-bold mb-1">Type:<span className="pl-3 text-muted text"> {approval.notificationType} </span></h6>
                                    <h6 className="fw-bold mb-1">Notification Status:<span className="pl-3 text-muted text">{approval.notificationStatus}</span></h6>
                                    <h6 className="fw-bold mb-1">Task Status:<span className="pl-3 text-muted text">{approval.taskStatus}</span></h6>
                                    <span className="text-muted text">{finalDescription}</span>
                                </div>
                                <div className="float-right ml-3">
                                    <div className="pt-1">
                                        {/* <small className="text-muted">Due : {approval.assignedDate}</small> */}
                                        <small className="text-muted">{approval.dateMessage}</small>
                                    </div>
                                    <div className="pt-1">
                                        {/* <small className="text-muted">Updated: {approval.updatedDateTime}</small> */}
                                        <button className="btn btn-primary btn-border btn-sm"
                                            onClick={() => {
                                                window.open(approval.link, '_blank');
                                                this.props.taskCleared(approval); //call clear task API
                                                this.props.sendStats(statAppname, statsUid); //call stats API
                                            }}
                                        >Go To App</button>
                                    </div>
                                </div>
                            </MediaQuery>
                            <MediaQuery maxDeviceWidth={1224}>
                                <div className="flex-1 ml-3 pt-1">
                                    <h6 className="text-uppercase mb-1">{curApprovalSysname}</h6>
                                    <h6 className="text-uppercase fw-bold mb-1">{approval.title} <span className="pl-3">{approval.approvalRequester}</span></h6>
                                    <div className="pt-1">
                                        {/* <small className="text-muted">Due : {approval.assignedDate}</small> */}
                                        <small className="text-muted">{approval.dateMessage}</small>
                                    </div>
                                    <div className="pt-1">
                                        {/* <small className="text-muted">Updated: {approval.updatedDateTime}</small> */}
                                        <button className="btn btn-primary btn-border btn-sm"
                                            onClick={() => {
                                                window.open(approval.link, '_blank');
                                                this.props.taskCleared(approval);
                                                this.props.sendStats(statAppname, statsUid); //call stats API
                                            }}>
                                            Go To App
                                        </button>
                                    </div>
                                </div>
                            </MediaQuery>
                        </div>
                    }
                    {/* end of EQUALS condition for SAPQN */}
                    {/* start of EQUALS condition for RCE */}
                    {curApprovalSysname === "RCE ServiceNow" &&
                        <div className="d-flex">
                            <a>
                                <div className="avatar">
                                    <span className="avatar-title rounded-circle border border-white" style={{ background: "#1C23BA" }}>{curApprovalSysname.charAt(0) + curApprovalSysname.charAt(1)}</span>
                                </div>
                            </a>
                            <MediaQuery minDeviceWidth={1225}>
                                <div className="flex-1 ml-3 pt-1">
                                    <h6 className="text-uppercase mb-1">Request for Capital Expenditure</h6>
                                    <h6 className="fw-bold mb-1">Project:<span className="pl-3 text-muted text"> {approval.projectId} </span></h6>
                                    <h6 className="fw-bold mb-1">RCE #:<span className="pl-3 text-muted text"> {approval.taskNumber} </span></h6>
                                    <h6 className="fw-bold mb-1">Prepared By:<span className="pl-3 text-muted text">{approval.createdBy}</span></h6>
                                    <h6 className="fw-bold mb-1">On Behalf Of:<span className="pl-3 text-muted text">{approval.onBehalfOf}</span></h6>
                                    <h6 className="fw-bold mb-1">Cost Center:<span className="pl-3 text-muted text">{approval.costCenter}</span></h6>
                                    <h6 className="fw-bold mb-1">RCE Requested Amount:<span className="pl-3 text-muted text">{approval.requestedAmount} {approval.currency}</span></h6>
                                    <h6 className="fw-bold mb-1">Previously Approved RCE:<span className="pl-3 text-muted text">{approval.previousApprovedAmount} {approval.currency}</span></h6>
                                    <h6 className="fw-bold mb-1">Total To Date:<span className="pl-3 text-muted text">{approval.totalRequested} {approval.currency}</span></h6>
                                </div>
                                <div className="ml-3">
                                    <div className="pt-1">
                                        {/* <small className="text-muted">Due : {approval.assignedDate}</small> */}
                                        <small className="text-muted">{approval.dateMessage}</small>
                                    </div>
                                    <div style={{ display: 'inline-block' }}>
                                        <button style={{ marginRight: "6px" }} className="btn btn-success btn-border btn-sm" onClick={() => {
                                            this.props.approveTask(approval, this.props.authState.accessToken);
                                            this.props.sendStats(statAppname, statsUid); //call stats API
                                        }}>Approve</button>
                                        <button style={{ marginRight: "6px" }} className="btn btn-danger btn-border btn-sm" onClick={() => {
                                            this.props.rejectTask(approval, this.props.authState.accessToken);
                                            this.props.sendStats(statAppname, statsUid); //call stats API
                                        }}>Reject</button>
                                    </div>
                                    <div className="pt-1" style={{ display: 'inline-block' }}>
                                        {/* <small className="text-muted">Updated: {approval.updatedDateTime}</small> */}
                                        <button className="btn btn-primary btn-border btn-sm"
                                            onClick={() => {
                                                window.open(approval.link, '_blank');
                                                this.props.sendStats(statAppname, statsUid); //call stats API
                                                //this.props.taskCleared(approval);
                                            }}
                                        >Go To App</button>
                                    </div>
                                </div>
                            </MediaQuery>
                            <MediaQuery maxDeviceWidth={1224}>
                                <div className="flex-1 ml-3 pt-1">
                                    <h6 className="text-uppercase mb-1">{curApprovalSysname}</h6>
                                    <h6 className="text-uppercase fw-bold mb-1">{approval.title} <span className="pl-3">{approval.approvalRequester}</span></h6>
                                    <div className="pt-1">
                                        {/* <small className="text-muted">Due : {approval.assignedDate}</small> */}
                                        <small className="text-muted">{approval.dateMessage}</small>
                                    </div>
                                    <div className="pt-1">
                                        {/* <small className="text-muted">Updated: {approval.updatedDateTime}</small> */}
                                        <button className="btn btn-primary btn-border btn-sm"
                                            onClick={() => {
                                                window.open(approval.link, '_blank');
                                                this.props.sendStats(statAppname, statsUid); //call stats API
                                                //this.props.taskCleared(approval);
                                            }}>
                                            Go To App
                                        </button>
                                    </div>
                                </div>
                            </MediaQuery>
                        </div>
                    }
                    {/* end of EQUALS condition for RCE */}

                    {curApprovalSysname !== "SAP QN" && curApprovalSysname !== "RCE ServiceNow" &&
                        <div className="d-flex">
                            <a>
                                {/* NEW  CODE BEGIN  */}
                                <div className="avatar">
                                    {/* NEW  CODE END  */}
                                    <span className="avatar-title rounded-circle border border-white" style={{ background: "#1C23BA" }}>{curApprovalSysname.charAt(0) + curApprovalSysname.charAt(1)}</span>
                                </div>
                            </a>
                            <MediaQuery minDeviceWidth={1225}>
                                <div className="flex-1 ml-3 pt-1">
                                    <h6 className="text-uppercase mb-1">{curApprovalSysname}</h6>
                                    <h6 className="text-uppercase fw-bold mb-1">{approval.title}</h6>
                                    {curApprovalSysname === "SAM" &&
                                        <div>
                                            <div>
                                                <div>
                                                    <span className="text-muted text">{approval.approvalRequester}</span>
                                                </div>
                                                {approval.entitlementArr.length !== 0 &&
                                                    <div>
                                                        <span className="text-muted text">Entitlements: </span>
                                                        {this.renderSamEntitlements({ approval })}
                                                    </div>
                                                }
                                            </div>
                                            {approval.finalAppArr.length !== 0 &&
                                                <div style={{ marginTop: "3px" }}>
                                                    <span className="text-muted text" >Applications: </span>
                                                    {this.renderSamApplications({ approval })}
                                                </div>
                                            }
                                        </div>
                                    }
                                    {curApprovalSysname !== "SAM" &&
                                        <span className="text-muted text">{finalDescription}</span>
                                    }
                                    {curApprovalSysname === "Ivalua" &&
                                        <div>
                                            <span className="text-muted text">Delegation: </span>
                                            <span className="text-muted text">{approval.delegation}</span>
                                        </div>
                                    }
                                </div>
                                <div className="float-right ml-3">
                                    <div className="pt-1" style={{ inlineSize: "90px", overflowWrap: "break-word" }}>
                                        {/* <small className="text-muted">Due : {approval.assignedDate}</small> */}
                                        <small className="text-muted">{approval.dateMessage}</small>
                                    </div>
                                    {curApprovalSysname === "RCE ServiceNow" &&
                                        <div style={{ display: 'inline-block' }}>
                                            <button style={{ marginRight: "6px" }} className="btn btn-success btn-border btn-sm" onClick={() => {
                                                this.props.approveTask(approval, this.props.authState.accessToken);
                                                this.props.sendStats(statAppname, statsUid); //call stats API
                                            }}>Approve</button>
                                            <button style={{ marginRight: "6px" }} className="btn btn-danger btn-border btn-sm" onClick={() => {
                                                this.props.rejectTask(approval, this.props.authState.accessToken);
                                                this.props.sendStats(statAppname, statsUid); //call stats API
                                            }}>Reject</button>
                                        </div>
                                    }
                                    <div className="pt-1" style={{ display: 'inline-block' }}>
                                        {/* <small className="text-muted">Updated: {approval.updatedDateTime}</small> */}
                                        <button className="btn btn-primary btn-border btn-sm"
                                            onClick={() => {
                                                window.open(approval.link, '_blank');
                                                this.props.taskCleared(approval);
                                                this.props.sendStats(statAppname, statsUid); //call stats API
                                            }}>
                                            Go To App
                                        </button>
                                    </div>
                                </div>
                            </MediaQuery>
                            <MediaQuery maxDeviceWidth={1224}>
                                <div className="flex-1 ml-3 pt-1">
                                    <h6 className="text-uppercase mb-1">{curApprovalSysname}</h6>
                                    <h6 className="text-uppercase fw-bold mb-1">{approval.title} <span className="pl-3">{approval.approvalRequester}</span></h6>
                                    <div className="pt-1 breakWord">
                                        {/* <small className="text-muted">Due : {approval.assignedDate}</small> */}
                                        <small className="text-muted">{approval.dateMessage}</small>
                                    </div>
                                    {curApprovalSysname === "RCE ServiceNow" &&
                                        <div style={{ display: 'inline-block' }}>
                                            <button style={{ marginRight: "6px" }} className="btn btn-success btn-border btn-sm" onClick={() => {
                                                this.props.approveTask(approval, this.props.authState.accessToken);
                                                this.props.sendStats(statAppname, statsUid); //call stats API
                                            }}>Approve</button>
                                            <button style={{ marginRight: "6px" }} className="btn btn-danger btn-border btn-sm" onClick={() => {
                                                this.props.rejectTask(approval, this.props.authState.accessToken);
                                                this.props.sendStats(statAppname, statsUid); //call stats API
                                            }}>Reject</button>
                                        </div>
                                    }
                                    <div className="pt-1" style={{ display: 'inline-block' }}>
                                        {/* <small className="text-muted">Updated: {approval.updatedDateTime}</small> */}
                                        <button className="btn btn-primary btn-border btn-sm"
                                            onClick={() => {
                                                window.open(approval.link, '_blank');
                                                this.props.taskCleared(approval);
                                                this.props.sendStats(statAppname, statsUid); //call stats API
                                            }}>
                                            Go To App
                                        </button>
                                    </div>
                                </div>
                            </MediaQuery>
                        </div>
                    }
                    {/* end of NOT condition for SAPQN */}
                    <div className="separator-dashed"></div>
                </div>
            );
        });
    }


    render() {
        return (
            <div className="card-body">
                {this.renderList()}
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    //console.log("STATE", state);
    // console.log("Cur Systems Agile : ", state.systems[1].amount);
    // console.log("Cur Systems ISU : ", state.systems[3].amount);
    // console.log("Cur Systems SAP QN : ", state.systems[4].amount);
    // console.log("Prev Systems Agile : ", state.previousSystemCounts[1].amount);
    // console.log("Prev Systems ISU : ", state.previousSystemCounts[3].amount);
    // console.log("Prev Systems SAP QN : ", state.previousSystemCounts[4].amount);
    // console.log("Previous Systems: ", state.previousSystemCounts);
    //console.log("USER STATE: ", state.user);
    return {
        approvals: state.approvals,
        curSystem: state.selectedSystem,
        approvalList: state.approvalList,
        dayFilter: state.dayFilter,
        user: state.user,
        dataFetchComplete: state.dataFetchComplete,
        isInitialDataFromRefresh: state.isInitialPulledData,
        curSystemCounts: state.systems,
        previousSystemCounts: state.previousSystemCounts
    };
}


export default connect(mapStateToProps, { fetchApprovals, taskCleared, updatePreviousSystemCounts, approveTask, rejectTask, sendStats })(withOktaAuth(NotificationListBs));